// src/components/AppHeader/AppHeader.js
import React from 'react';
import PropTypes from 'prop-types';
import HamburgerMenu from '../../HamburgerMenu';
import HeaderLogo from '../../HeaderLogo';
import OrgInstallDisplay from '../OrgInstallDisplay';
import './AppHeader.css';

/**
 * AppHeader - Main application header component
 * 
 * Displays hamburger menu, page title, logo, and organization/installation info.
 * Supports both device management and patron management views.
 */
const AppHeader = ({
  currentView,
  title,
  theme,
  activeLogo,
  onToggleLogo,
  organizationId,
  organizationName,
  installationId,
  installationName,
  // Hamburger menu props
  onNavigateToPatrons,
  onNavigateToDevices,
  onOpenAdvancedSettings,
  onOpenInstallationActions,
  onOpenInstallationManagement,
  onOpenOrganizationManagement,
  onToggleDevStreams,
  deviceCount,
  devices,
  onDevicesClaimed,
  allDeviceStatesLoaded,
  currentOrgSettings,
  orgInstallContext,
}) => {
  return (
    <>
      {/* Hamburger Menu */}
      <HamburgerMenu
        onNavigateToPatrons={onNavigateToPatrons}
        onNavigateToDevices={onNavigateToDevices}
        onOpenAdvancedSettings={onOpenAdvancedSettings}
        onOpenInstallationActions={onOpenInstallationActions}
        onOpenInstallationManagement={onOpenInstallationManagement}
        onOpenOrganizationManagement={onOpenOrganizationManagement}
        onToggleDevStreams={onToggleDevStreams}
        deviceCount={deviceCount}
        devices={devices}
        onDevicesClaimed={onDevicesClaimed}
        allDeviceStatesLoaded={allDeviceStatesLoaded}
        currentOrgSettings={currentOrgSettings}
        orgInstallContext={orgInstallContext}
      />

      {/* Header */}
      <header className="App-header">
        <h1>{title}</h1>
        <div className="header-logo-container">
          <HeaderLogo
            theme={theme}
            activeLogo={activeLogo}
            onToggleLogo={onToggleLogo}
          />
        </div>
        <div className="org-install-in-header">
          <OrgInstallDisplay
            organizationId={organizationId}
            organizationName={organizationName}
            installationId={installationId}
            installationName={installationName}
          />
        </div>
      </header>
    </>
  );
};

AppHeader.propTypes = {
  currentView: PropTypes.oneOf(['devices', 'patrons']),
  title: PropTypes.string.isRequired,
  theme: PropTypes.string.isRequired,
  activeLogo: PropTypes.string,
  onToggleLogo: PropTypes.func.isRequired,
  organizationId: PropTypes.string,
  organizationName: PropTypes.string,
  installationId: PropTypes.string,
  installationName: PropTypes.string,
  // Hamburger menu props
  onNavigateToPatrons: PropTypes.func.isRequired,
  onNavigateToDevices: PropTypes.func.isRequired,
  onOpenAdvancedSettings: PropTypes.func.isRequired,
  onOpenInstallationActions: PropTypes.func.isRequired,
  onOpenInstallationManagement: PropTypes.func.isRequired,
  onOpenOrganizationManagement: PropTypes.func.isRequired,
  onToggleDevStreams: PropTypes.func.isRequired,
  deviceCount: PropTypes.number,
  devices: PropTypes.array,
  onDevicesClaimed: PropTypes.func.isRequired,
  allDeviceStatesLoaded: PropTypes.bool,
  currentOrgSettings: PropTypes.object,
  orgInstallContext: PropTypes.object,
};

AppHeader.defaultProps = {
  deviceCount: 0,
  devices: [],
};

export default AppHeader;
